import { render, staticRenderFns } from "./LuckyDrawReward.vue?vue&type=template&id=7b9fa0a5&scoped=true"
import script from "./LuckyDrawReward.vue?vue&type=script&lang=ts"
export * from "./LuckyDrawReward.vue?vue&type=script&lang=ts"
import style0 from "./LuckyDrawReward.vue?vue&type=style&index=0&id=7b9fa0a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9fa0a5",
  null
  
)

export default component.exports